//Singleton pattern
class C7Api {
    private static instance: C7Api;
    private baseUrl: string = 'https://colectivosiete.com'; 
    private constructor() {}
  
    public static getInstance(): C7Api {
      if (!C7Api.instance) {
        C7Api.instance = new C7Api();
      }
      return C7Api.instance;
    }

    public getBaseUrl(): string {
      return this.baseUrl;
    }
  
    public async get(endpoint: string): Promise<any> {
      const response = await fetch(`${this.baseUrl}/${endpoint}`);
      if (!response.ok) throw new Error('Error en la solicitud GET');
      return response.json();
    }
  
 public async post(endpoint: string, data: any): Promise<any>{

  const response = await fetch(`${this.baseUrl}/${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) throw new Error('Error en la solicitud POST');

  return response.json();
}


    public async postFormData(endpoint:string, formData: FormData): Promise<any>{
      const response = await fetch(`${this.baseUrl}/${endpoint}`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) throw new Error('Error en la solicitud POST Media');
      return response.json();
    }
  
    public async put(endpoint: string, data: any): Promise<any> {
        const response = await fetch(`${this.baseUrl}/${endpoint}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error('Error en la solicitud PUT');
        return response.json();
      }
    
      public async patch(endpoint: string, data: any): Promise<any> {
        const response = await fetch(`${this.baseUrl}/${endpoint}`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error('Error en la solicitud PATCH');
        return response.json();
      }
    
      public async delete(endpoint: string): Promise<any> {
        const response = await fetch(`${this.baseUrl}/${endpoint}`, {
          method: 'DELETE',
        });
        if (!response.ok) throw new Error('Error en la solicitud DELETE');
        return response.json();
      }
  }
  
  export const c7Api = C7Api.getInstance();
  